import useStyles from "./styles"
import ExternalLink from "./components/ExternalLink"
import InternalLink from "./components/InternalLink"
import FooterListIcon from "./components/FooterListIcon"
import logo from "../../assets/largelogo.png"
import { strings as Localization } from "../../lib/Localization"
import { useLanguage } from "../../lib/hooks/languageHooks"
import { useProxyPath } from "../../redux/hook/settingsHooks"
import {
    Typography, List, Box, Grid, Divider
} from "@material-ui/core"
import React from "react"

const Footer = () => {
    const language = useLanguage()
    const classes = useStyles()
    const [data, setData] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const proxyPath = useProxyPath()

    const fetchStaticData = async () => {
        setLoading(true)
        const response = await fetch("/files/DynamicPages/FooterLinks.json")
        setLoading(false)
        return response.json()
    }

    React.useEffect(() => {
        fetchStaticData().then(result => setData(result))
    }, [false])

    return (
        <footer className={classes.root}>
            <Divider />
            <Box height={20} />
            {" "}
            { /* för lite space uppåt, sätt lite avstånd på den här :) */}
            {
                (loading && data.length <= 0)
                && (
                    <Typography>
                        {Localization.loading}
                        ...
                    </Typography>
                )
            }
            <Grid container spacing={2} justifyContent="space-between">
                {
                    data.map(section => {
                        const { contents, displayText } = section
                        return (
                            <Grid item key={section.id} xs={12} sm={12} md={6} lg={2}>
                                <Typography variant="h5" className={classes.capitalized}>{displayText.filter(x => x.lang === language)[0].text}</Typography>
                                <List dense className="footerLink">
                                    {contents.map(content => {
                                        const icon = FooterListIcon(content.icon)

                                        return (
                                            content.externalLink
                                                ? ExternalLink(content, icon, language)
                                                : InternalLink(content, icon, language, proxyPath)
                                        )
                                    })}
                                </List>
                            </Grid>
                        )
                    })
                }
                <Grid item>
                    <img src={logo} alt="Brodit logo" height="80px" />
                </Grid>
            </Grid>
        </footer>
    )
}

export default Footer
